import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerModello770ModalComponent} from './worker-modello-770-modal';

export const WorkerModello770ModalModule: string = ng
    .module('worker-modello_770-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerModello770ModalComponent', WorkerModello770ModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-modello-770-modal/worker-modello-770-modal.module.ts